import { render, staticRenderFns } from "./WPStatusViewer.vue?vue&type=template&id=ea70eafc&scoped=true"
import script from "./WPStatusViewer.vue?vue&type=script&lang=js"
export * from "./WPStatusViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea70eafc",
  null
  
)

export default component.exports